export const productGallery = () => {
    const mainImageElement = document.querySelector('.product-img img');
    const imageElements = document.querySelectorAll('.product-gallery-imgs img');
    const arrowLeftButton = document.querySelector('.arrow-left');
    const arrowRightButton = document.querySelector('.arrow-right');

    if (!imageElements || imageElements.length === 0) {
        return;
    }

    let mainImage = imageElements[0].getAttribute('src');
    let currentIndex = 0;

    const images = [];
    imageElements.forEach((imageElement) => {
        images.push(imageElement.getAttribute('src'));
    });

    const updateImage = (index) => {
        mainImage = images[index];
        currentIndex = index;
        mainImageElement.setAttribute('src', mainImage);
    };

    const previousImage = () => {
        currentIndex = (currentIndex - 1 + images.length) % images.length;
        mainImage = images[currentIndex];
        mainImageElement.setAttribute('src', mainImage);
    };

    const nextImage = () => {
        currentIndex = (currentIndex + 1) % images.length;
        mainImage = images[currentIndex];
        mainImageElement.setAttribute('src', mainImage);
    };

    imageElements.forEach((imageElement, index) => {
        if (imageElement) {
            imageElement.addEventListener('click', () => {
                updateImage(index);
            });
        }
    });

    if (arrowLeftButton) {
        arrowLeftButton.addEventListener('click', () => {
            previousImage();
        });
    }

    if (arrowRightButton) {
        arrowRightButton.addEventListener('click', () => {
            nextImage();
        });
    }
};